<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="アカウント管理"
      />
      <div class="grid-x align-justify">
        <div class="medium-9 cell">
          <p>この企業様管理画面にログインできるご担当者様の各種設定を行います。</p>
          <p>
            ※設定の変更が行えるのは、設定管理者に設定されているご担当者様のみです。
            <br>※ユーザーは１０人まで登録できます。
          </p>
        </div>
        <div
          v-if="isEditAccount"
          data-test="create-account"
          class="medium-3 cell"
        >
          <button
            class="float-right boss-button boss-button-new"
            data-test="button-add-account"
            @click="$router.push({ name: 'settingAccountRegister' })"
          >
            <span class="boss-icon-new" />
            <span class="boss-button-new-text">アカウントを追加する</span>
          </button>
        </div>
      </div>
      <table class="unstriped hover boss-table">
        <thead>
          <tr>
            <th class="boss-table-head-center boss-user-name">
              氏名
            </th>
            <th class="boss-table-head-center">
              メールアドレス
            </th>
            <th class="boss-table-head-center boss-permissions">
              権限設定
            </th>
            <th class="boss-table-head-center">
              メール受信設定
            </th>
            <template v-if="isEditAccount">
              <th class="boss-table-head-center boss-operation">
                編集
              </th>
              <th class="boss-table-head-center boss-operation">
                削除
              </th>
              <th class="boss-table-head-center boss-temporary-password">
                ID/仮PASS送信
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(staff, i) in staffs"
            :key="i"
          >
            <td class="boss-table-data">
              <span :data-test="'staff-name-' + i">{{ staff.staffName| formatData }}</span><br>
              <span
                v-if="staff.isAdmin"
                :data-test="'staff-name-admin-' + i"
                class="boss-annotation-text"
              ><b>※設定管理者</b></span>
            </td>
            <td
              :data-test="'staff-address-' + i"
              class="boss-table-data pega-break"
            >
              {{ staff.email | formatData }}
            </td>
            <td class="boss-table-data">
              <div
                v-for="(permission,j) in staff.permissions"
                :key="j"
                :data-test="'staff-permission-' + i+'-'+j"
                class="text-left"
              >
                {{ permission.name }}
              </div>
            </td>
            <td
              class="boss-table-data"
            >
              <div
                v-for="(receivableMailType,j) in staff.receivableMailTypes"
                :key="j"
                :data-test="'staff-receivable-mail-type-' + i+'-'+j"
                class="text-left"
              >
                {{ receivableMailType.name }}
              </div>
            </td>
            <template v-if="isEditAccount">
              <td class="boss-table-data">
                <button
                  :data-test="'staff-edit-icon-' + i"
                  class="boss-icon-pencil"
                  @click="$router.push({ name: 'settingAccountEdit', params: { id:staff.id }})"
                />
              </td>
              <td class="boss-table-data">
                <button
                  v-if="!staff.isAdmin"
                  :data-test="'staff-delete-icon-' + i"
                  class="boss-icon-trash"
                  @click="doRemove(staff.id)"
                />
              </td>
              <td class="boss-table-data">
                <button
                  v-if="!staff.isAdmin"
                  :data-test="'staff-id-pass-button-' + i"
                  class="boss-button"
                  @click="doSend(staff.id)"
                >
                  <span class="boss-button-new-text">ID/仮PASS送信</span>
                </button>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import { mapGetters } from 'vuex'
import Indicator from '@/lib/indicator'

export default {
  components: {
    SettingHeader
  },
  filters: {
    formatData (val) {
      return val || '未登録'
    }
  },
  data () {
    return {
      staffs: []
    }
  },
  computed: {
    ...mapGetters([
      'isEditAccount'
    ])
  },
  created () {
    this.fetchStaffs()
  },
  methods: {
    fetchStaffs () {
      Indicator.emitShow()
      this.$http.secured.get('/account/view/staff')
        .then(response => this.$set(this, 'staffs', response.data))
        .finally(() => { Indicator.emitHide() })
    },
    removeStaff (id) {
      return this.$http.secured.delete(`/account/edit/settings/staff/${id}`)
    },
    sendIdPassMail (id) {
      return this.$http.secured.post('/account/edit/settings/send_tmp_mail', id)
    },
    doRemove (id) {
      this.$dialog.confirm('削除しますか？')
      // はいを押下した時
        .then(() => {
          this.removeStaff(id) // 削除して
            .then(() => {
              this.$toasted.global.success({ message: 'アカウント削除しました。' })
              this.fetchStaffs() // 一覧情報を取り直す
            })
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    },
    doSend (id) {
      this.$dialog.confirm('仮パスワードを再発行しますか？')
      // はいを押下した時
        .then(() => {
          this.sendIdPassMail(id).then(() => {
            this.$toasted.global.success({ message: 'ID/仮パスワード通知メールを送信しました。' })
          })
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    }
  }
}
</script>
